module.exports = __webpack_public_path__ + "media/images/switch-e7984fe9367189a72595107baf8124a4.png";